import { useBusinessContext } from '@root/context'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { fetchUsershipTags } from '../constants'

export const useUsershipTags = () => {
  const { slug } = useBusinessContext()

  return useQuery({
    queryKey: [slug, 'usership_tags'],
    queryFn: () => fetchUsershipTags({ slug }),
    placeholderData: keepPreviousData,
    staleTime: 6 * 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!slug
  })
}
